define('OutSystems/ClientRuntime/DataConversion',["require", "exports", "./BuiltinFunctions", "./DataTypes", "./Exceptions", "./Interfaces", "./modules/Database/DatabaseTypeUtils", "./Settings"], function (require, exports, BuiltinFunctions, DataTypes_1, Exceptions_1, Interfaces_1, DatabaseTypeUtils_1, Settings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LocalStorageConverter = exports.NewJSONConverter = exports.JSONConverter = exports.JSNodeParamConverter = exports.JSConversions = exports.ServerDataConverter = void 0;
    function isGenericRecordType(dataType) {
        return !!dataType.isGenericRecordType;
    }
    function isGenericRecordListType(dataType) {
        return !!dataType.isGenericRecordListType;
    }
    function isBasicTypeListType(dataType) {
        return !!dataType.isBasicTypeListType;
    }
    var ServerDataConverter;
    (function (ServerDataConverter) {
        var ToMethodCache = new Map();
        var FromMethodCache = new Map();
        function to(value, dataTypeOrCallContext, callContextOrOptimizeList, optimizeList) {
            if (dataTypeOrCallContext === void 0) { dataTypeOrCallContext = DataTypes_1.DataTypes.Record; }
            if (callContextOrOptimizeList === void 0) { callContextOrOptimizeList = false; }
            if (optimizeList === void 0) { optimizeList = false; }
            if (value === undefined || value === null) {
                return;
            }
            var dataType = DataTypes_1.DataTypes.Record;
            var callContext;
            if (typeof dataTypeOrCallContext !== "number") {
                optimizeList = callContextOrOptimizeList === true;
                callContext = dataTypeOrCallContext;
                dataType = DataTypes_1.DataTypes.Record;
            }
            else {
                dataType = dataTypeOrCallContext;
                if (typeof callContextOrOptimizeList !== "boolean") {
                    callContext = callContextOrOptimizeList;
                }
            }
            if (value instanceof DataTypes_1.GenericRecord) {
                var record = value;
                var recordType = record.constructor;
                var converter = ToMethodCache.get(recordType);
                if (!converter) {
                    var attributes = record.getAttributes();
                    var toFuncCode_1 = "return function to(record, callContext, optimizeList) {\n";
                    toFuncCode_1 += "    return {\n";
                    attributes.forEach(function (attr, index) {
                        if (!attr.ignoreForServer) {
                            if (attr.dataType === DataTypes_1.DataTypes.Record || attr.dataType === DataTypes_1.DataTypes.RecordList) {
                                toFuncCode_1 += "        " + attr.name + ": toServerData(record." + attr.attrName + ", callContext, " + attr.optimizeList + " && optimizeList),\n";
                            }
                            else if (attr.dataType !== DataTypes_1.DataTypes.Object) {
                                toFuncCode_1 += "        " + attr.name + ": basicTypeToJS(record." + attr.attrName + ", attributes[" + index + "].dataType),\n";
                            }
                        }
                    });
                    toFuncCode_1 += "    };\n";
                    toFuncCode_1 += "};";
                    converter = new Function("toServerData", "basicTypeToJS", "attributes", toFuncCode_1)(to, basicTypeToJS, attributes);
                    ToMethodCache.set(recordType, converter);
                }
                return converter(value, callContext, optimizeList);
            }
            else if (value instanceof DataTypes_1.List) {
                var list = value;
                var listItemType = list.constructor.getItemType();
                var result = {
                    List: [],
                };
                if (!optimizeList || !callContext) {
                    for (var i = 0; i < list.length; i++) {
                        result.List.push(to(list.getItem(i), listItemType));
                    }
                }
                else {
                    if (list.length > 0 && callContext) {
                        var currentRow = callContext.iterationContext.getCurrentRowNumber(value);
                        result.List.push(to(list.getItem(currentRow), listItemType, callContext, optimizeList));
                    }
                }
                if (list.isEmpty) {
                    result.EmptyListItem = to(list.emptyListItem, listItemType, callContext, optimizeList);
                }
                return result;
            }
            else if (dataType !== DataTypes_1.DataTypes.Object) {
                return basicTypeToJS(value, dataType);
            }
        }
        ServerDataConverter.to = to;
        function from(jsObject, dataType) {
            if (isGenericRecordType(dataType)) {
                var recordType = dataType;
                var converter = FromMethodCache.get(recordType);
                if (!converter) {
                    var attributes = recordType.getAttributes();
                    var fromFuncCode_1 = "return function from(obj) {\n";
                    fromFuncCode_1 += "    if (!obj) { obj = {}; }\n";
                    fromFuncCode_1 += "    return new classDef(new classDef.RecordClass({\n";
                    attributes.forEach(function (attr, index) {
                        if (attr.dataType === DataTypes_1.DataTypes.Record || attr.dataType === DataTypes_1.DataTypes.RecordList) {
                            fromFuncCode_1 += "        " + attr.attrName + ": GenericRecord.getData(fromServerData(obj." + attr.name + ", attributes[" + index + "].complexType)),\n";
                        }
                        else if (attr.dataType === DataTypes_1.DataTypes.BinaryData) {
                            fromFuncCode_1 += "        " + attr.attrName + ": jsToBasicType({ content: obj." + attr.name + ", url: obj._" + attr.name + "URL }, attributes[" + index + "].dataType),\n";
                        }
                        else {
                            fromFuncCode_1 += "        " + attr.attrName + ": jsToBasicType(obj." + attr.name + ", attributes[" + index + "].dataType),\n";
                        }
                    });
                    fromFuncCode_1 += "    }));\n";
                    fromFuncCode_1 += "};";
                    converter = new Function("fromServerData", "jsToBasicType", "GenericRecord", "attributes", "classDef", fromFuncCode_1)(from, jsToBasicType, DataTypes_1.GenericRecord, attributes, recordType);
                    FromMethodCache.set(recordType, converter);
                }
                return converter(jsObject);
            }
            else if (isGenericRecordListType(dataType) || isBasicTypeListType(dataType)) {
                if (dataType.getItemType() === undefined || dataType.getItemType() === null) {
                    throw Error("A List can only be deserialized if its ItemType is defined.");
                }
                var constructableDataType = dataType;
                var result = new constructableDataType();
                if (jsObject.List.length === 0) {
                    result.emptyListItem = from(jsObject.EmptyListItem, dataType.getItemType());
                }
                else {
                    result.pushAll(jsObject.List.map(function (item) { return from(item, dataType.getItemType()); }));
                }
                return result;
            }
            else {
                return jsToBasicType(jsObject, dataType);
            }
        }
        ServerDataConverter.from = from;
        function basicTypeToJS(value, valueType) {
            switch (valueType) {
                case DataTypes_1.DataTypes.Integer:
                    return value;
                case DataTypes_1.DataTypes.LongInteger:
                    return BuiltinFunctions.longIntegerToText(value);
                case DataTypes_1.DataTypes.Decimal:
                case DataTypes_1.DataTypes.Currency:
                    return BuiltinFunctions.decimalToText(value);
                case DataTypes_1.DataTypes.Text:
                case DataTypes_1.DataTypes.PhoneNumber:
                case DataTypes_1.DataTypes.Email:
                    return value;
                case DataTypes_1.DataTypes.Date:
                    return value.toISODate();
                case DataTypes_1.DataTypes.DateTime:
                    return value.toString();
                case DataTypes_1.DataTypes.Time:
                    return value.toISOTime();
                case DataTypes_1.DataTypes.Boolean:
                    return value;
                case DataTypes_1.DataTypes.Record:
                case DataTypes_1.DataTypes.RecordList:
                    throw new TypeError("Records and Record lists are not basic types");
                case DataTypes_1.DataTypes.BinaryData:
                    return typeof value === "string" ? value : value.content;
                case DataTypes_1.DataTypes.Object:
                    return value;
                default:
                    return value;
            }
        }
        function jsToBasicType(value, targetType) {
            switch (targetType) {
                case DataTypes_1.DataTypes.Integer:
                    DataTypes_1.TypeValidations.ensureIntegerInsideBounds(value);
                    return value | 0;
                case DataTypes_1.DataTypes.LongInteger:
                    return typeof value === "string"
                        ? DataTypes_1.LongInteger.fromString(value)
                        : DataTypes_1.LongInteger.fromNumber(value);
                case DataTypes_1.DataTypes.Decimal:
                case DataTypes_1.DataTypes.Currency:
                    return new DataTypes_1.Decimal(value || "0");
                case DataTypes_1.DataTypes.Boolean:
                    return typeof value === "string" ? BuiltinFunctions.textToBoolean(value) : value;
                case DataTypes_1.DataTypes.Text:
                case DataTypes_1.DataTypes.PhoneNumber:
                case DataTypes_1.DataTypes.Email:
                    if (value === undefined) {
                        return "";
                    }
                    return value + "";
                case DataTypes_1.DataTypes.Date:
                    if (value instanceof Date) {
                        return new DataTypes_1.DateTime(value);
                    }
                    return DataTypes_1.DateTime.fromISODate(value);
                case DataTypes_1.DataTypes.DateTime:
                    if (value instanceof Date) {
                        return new DataTypes_1.DateTime(value);
                    }
                    return DataTypes_1.DateTime.fromISODateTime(value);
                case DataTypes_1.DataTypes.Time:
                    if (value instanceof Date) {
                        return new DataTypes_1.DateTime(value);
                    }
                    return DataTypes_1.DateTime.fromISOTime(value);
                case DataTypes_1.DataTypes.Record:
                case DataTypes_1.DataTypes.RecordList:
                    throw new TypeError("Records and Record lists are not basic types");
                case DataTypes_1.DataTypes.BinaryData:
                    if (DataTypes_1.TypeValidations.hasBinaryDataInterface(value)) {
                        return new DataTypes_1.BinaryData(value.content, value.url);
                    }
                    return new DataTypes_1.BinaryData(value);
                case DataTypes_1.DataTypes.Object:
                    return value;
                default:
                    return value;
            }
        }
    })(ServerDataConverter = exports.ServerDataConverter || (exports.ServerDataConverter = {}));
    var JSConversions;
    (function (JSConversions) {
        function isConvertibleToInteger(value) {
            if (DataTypes_1.TypeValidations.isValidJsNumber(value) &&
                value >= DataTypes_1.Constants.MIN_INTEGER_VALUE &&
                value <= DataTypes_1.Constants.MAX_INTEGER_VALUE) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isLongInteger(value)) {
                return BuiltinFunctions.longIntegerToIntegerValidate(value);
            }
            else if (DataTypes_1.TypeValidations.isDecimal(value)) {
                return BuiltinFunctions.decimalToIntegerValidate(value);
            }
            else if (DataTypes_1.TypeValidations.isText(value)) {
                return BuiltinFunctions.textToIntegerValidate(value);
            }
            else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                return true;
            }
            return false;
        }
        function isConvertibleToLongInteger(value) {
            if (DataTypes_1.TypeValidations.isValidJsNumber(value)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isValidLongInteger(value)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isValidDecimal(value)) {
                return BuiltinFunctions.decimalToLongIntegerValidate(value);
            }
            else if (DataTypes_1.TypeValidations.isText(value)) {
                return BuiltinFunctions.textToLongIntegerValidate(value);
            }
            else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                return true;
            }
            return false;
        }
        function isConvertibleToDecimal(value) {
            if (DataTypes_1.TypeValidations.isValidJsNumber(value)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isValidDecimal(value) &&
                DataTypes_1.Constants.MIN_DECIMAL_VALUE.lte(value) &&
                DataTypes_1.Constants.MAX_DECIMAL_VALUE.gte(value)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isValidLongInteger(value)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isText(value)) {
                return BuiltinFunctions.textToDecimalValidate(value);
            }
            else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                return true;
            }
            return false;
        }
        function isConvertibleToCurrency(value) {
            return isConvertibleToDecimal(value);
        }
        function isConvertibleToText(value) {
            if (DataTypes_1.TypeValidations.isJsNumber(value)) {
                return DataTypes_1.TypeValidations.isValidJsNumber(value);
            }
            else if (DataTypes_1.TypeValidations.isLongInteger(value)) {
                return DataTypes_1.TypeValidations.isValidLongInteger(value);
            }
            else if (DataTypes_1.TypeValidations.isDecimal(value)) {
                return DataTypes_1.TypeValidations.isValidDecimal(value);
            }
            else if (DataTypes_1.TypeValidations.isText(value)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isDateTime(value)) {
                return DataTypes_1.TypeValidations.isValidDateTime(value);
            }
            else if (DataTypes_1.TypeValidations.isJsDate(value)) {
                return DataTypes_1.TypeValidations.isValidJsDate(value);
            }
            return false;
        }
        function isConvertibleToPhoneNumber(value) {
            return isConvertibleToText(value);
        }
        function isConvertibleToEmail(value) {
            return isConvertibleToText(value);
        }
        function isConvertibleToBoolean(value) {
            if (DataTypes_1.TypeValidations.isJsNumber(value)) {
                return DataTypes_1.TypeValidations.isValidJsNumber(value);
            }
            else if (DataTypes_1.TypeValidations.isLongInteger(value)) {
                return DataTypes_1.TypeValidations.isValidLongInteger(value);
            }
            else if (DataTypes_1.TypeValidations.isDecimal(value)) {
                return DataTypes_1.TypeValidations.isValidDecimal(value);
            }
            else if (DataTypes_1.TypeValidations.isText(value)) {
                return /^(true)|(false)$/gi.test(value);
            }
            else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                return true;
            }
            return false;
        }
        function isConvertibleToDate(value) {
            if (DataTypes_1.TypeValidations.isValidDateTime(value) &&
                value.gte(DataTypes_1.Constants.MIN_DATE_VALUE) &&
                value.lte(DataTypes_1.Constants.MAX_DATE_VALUE)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isValidJsDate(value) &&
                new DataTypes_1.DateTime(value).gte(DataTypes_1.Constants.MIN_DATE_VALUE) &&
                new DataTypes_1.DateTime(value).lte(DataTypes_1.Constants.MAX_DATE_VALUE)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isText(value)) {
                if (DataTypes_1.Constants.ISO_DATE_FORMAT_REGEXP.test(value)) {
                    var date = new DataTypes_1.DateTime(new Date(value));
                    return date.gte(DataTypes_1.Constants.MIN_DATE_VALUE) && date.lte(DataTypes_1.Constants.MAX_DATE_VALUE);
                }
                else if (!BuiltinFunctions.textToDateValidate(value)) {
                    return false;
                }
                else {
                    var date = BuiltinFunctions.textToDate(value);
                    return date.gte(DataTypes_1.Constants.MIN_DATE_VALUE) && date.lte(DataTypes_1.Constants.MAX_DATE_VALUE);
                }
            }
            return false;
        }
        function isConvertibleToTime(value) {
            if (DataTypes_1.TypeValidations.isValidDateTime(value)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isValidJsDate(value)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isText(value)) {
                if (DataTypes_1.Constants.RFC3339_TIMEPART.test(value) || DataTypes_1.Constants.ISO_DATE_FORMAT_REGEXP.test(value)) {
                    return true;
                }
                else {
                    return BuiltinFunctions.textToTimeValidate(value);
                }
            }
            return false;
        }
        function isConvertibleToDateTime(value) {
            if (DataTypes_1.TypeValidations.isValidDateTime(value) &&
                value.gte(DataTypes_1.Constants.MIN_DATETIME_VALUE) &&
                value.lte(DataTypes_1.Constants.MAX_DATETIME_VALUE)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isValidJsDate(value) &&
                new DataTypes_1.DateTime(value).gte(DataTypes_1.Constants.MIN_DATETIME_VALUE) &&
                new DataTypes_1.DateTime(value).lte(DataTypes_1.Constants.MAX_DATETIME_VALUE)) {
                return true;
            }
            else if (DataTypes_1.TypeValidations.isText(value)) {
                if (DataTypes_1.Constants.ISO_DATE_FORMAT_REGEXP.test(value)) {
                    var dateTime = new DataTypes_1.DateTime(new Date(value));
                    return dateTime.gte(DataTypes_1.Constants.MIN_DATETIME_VALUE) && dateTime.lte(DataTypes_1.Constants.MAX_DATETIME_VALUE);
                }
                else if (!BuiltinFunctions.textToDateTimeValidate(value)) {
                    return false;
                }
                else {
                    var dateTime = BuiltinFunctions.textToDateTime(value);
                    return dateTime.gte(DataTypes_1.Constants.MIN_DATETIME_VALUE) && dateTime.lte(DataTypes_1.Constants.MAX_DATETIME_VALUE);
                }
            }
            return false;
        }
        function isConvertibleToBinaryData(value) {
            return DataTypes_1.TypeValidations.isBinaryData(value);
        }
        function isConvertibleTo(value, type) {
            switch (type) {
                case DataTypes_1.DataTypes.Integer:
                    return isConvertibleToInteger(value);
                case DataTypes_1.DataTypes.LongInteger:
                    return isConvertibleToLongInteger(value);
                case DataTypes_1.DataTypes.Decimal:
                    return isConvertibleToDecimal(value);
                case DataTypes_1.DataTypes.Currency:
                    return isConvertibleToCurrency(value);
                case DataTypes_1.DataTypes.Text:
                    return isConvertibleToText(value);
                case DataTypes_1.DataTypes.PhoneNumber:
                    return isConvertibleToPhoneNumber(value);
                case DataTypes_1.DataTypes.Email:
                    return isConvertibleToEmail(value);
                case DataTypes_1.DataTypes.Boolean:
                    return isConvertibleToBoolean(value);
                case DataTypes_1.DataTypes.Date:
                    return isConvertibleToDate(value);
                case DataTypes_1.DataTypes.Time:
                    return isConvertibleToTime(value);
                case DataTypes_1.DataTypes.DateTime:
                    return isConvertibleToDateTime(value);
                case DataTypes_1.DataTypes.BinaryData:
                    return isConvertibleToBinaryData(value);
                default:
                    return false;
            }
        }
        JSConversions.isConvertibleTo = isConvertibleTo;
        function isDefault(value) {
            return ((DataTypes_1.TypeValidations.isValidJsNumber(value) && value === DataTypes_1.Constants.DEFAULT_INTEGER) ||
                (DataTypes_1.TypeValidations.isValidLongInteger(value) &&
                    value.equals(DataTypes_1.Constants.DEFAULT_LONGINTEGER)) ||
                (DataTypes_1.TypeValidations.isValidDecimal(value) && value.equals(DataTypes_1.Constants.DEFAULT_DECIMAL)) ||
                (DataTypes_1.TypeValidations.isText(value) && value === DataTypes_1.Constants.DEFAULT_TEXT) ||
                (DataTypes_1.TypeValidations.isBoolean(value) && value === DataTypes_1.Constants.DEFAULT_BOOLEAN) ||
                (DataTypes_1.TypeValidations.isValidDateTime(value) && value.equals(DataTypes_1.Constants.DEFAULT_DATETIME)));
        }
        JSConversions.isDefault = isDefault;
        function convertToInteger(value) {
            if (isConvertibleToInteger(value)) {
                if (DataTypes_1.TypeValidations.isJsNumber(value)) {
                    return BuiltinFunctions.objectToInteger(value);
                }
                else if (DataTypes_1.TypeValidations.isLongInteger(value)) {
                    return BuiltinFunctions.objectToInteger(value);
                }
                else if (DataTypes_1.TypeValidations.isDecimal(value)) {
                    return BuiltinFunctions.objectToInteger(value);
                }
                else if (DataTypes_1.TypeValidations.isText(value) && value !== "") {
                    return BuiltinFunctions.textToInteger(value);
                }
                else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                    return BuiltinFunctions.booleanToInteger(value);
                }
            }
            return DataTypes_1.Constants.DEFAULT_INTEGER;
        }
        function convertToLongInteger(value) {
            if (isConvertibleToLongInteger(value)) {
                if (DataTypes_1.TypeValidations.isJsNumber(value)) {
                    return BuiltinFunctions.objectToLongInteger(value);
                }
                else if (DataTypes_1.TypeValidations.isLongInteger(value)) {
                    return BuiltinFunctions.objectToLongInteger(value);
                }
                else if (DataTypes_1.TypeValidations.isDecimal(value)) {
                    return BuiltinFunctions.objectToLongInteger(value);
                }
                else if (DataTypes_1.TypeValidations.isText(value) && value !== "") {
                    return BuiltinFunctions.textToLongInteger(value);
                }
                else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                    return BuiltinFunctions.booleanToLongInteger(value);
                }
            }
            return DataTypes_1.Constants.DEFAULT_LONGINTEGER;
        }
        function convertToDecimal(value) {
            if (isConvertibleToDecimal(value)) {
                if (DataTypes_1.TypeValidations.isJsNumber(value)) {
                    return BuiltinFunctions.objectToDecimal(value);
                }
                else if (DataTypes_1.TypeValidations.isLongInteger(value)) {
                    return BuiltinFunctions.objectToDecimal(value);
                }
                else if (DataTypes_1.TypeValidations.isDecimal(value)) {
                    return BuiltinFunctions.objectToDecimal(value);
                }
                else if (DataTypes_1.TypeValidations.isText(value) && value !== "") {
                    return BuiltinFunctions.textToDecimal(value);
                }
                else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                    return BuiltinFunctions.booleanToDecimal(value);
                }
            }
            return DataTypes_1.Constants.DEFAULT_DECIMAL;
        }
        function convertToCurrency(value) {
            return convertToDecimal(value);
        }
        function convertToText(value) {
            if (isConvertibleToText(value)) {
                if (DataTypes_1.TypeValidations.isJsNumber(value)) {
                    if (DataTypes_1.TypeValidations.isValidInteger(value)) {
                        return BuiltinFunctions.integerToText(value);
                    }
                    else {
                        return BuiltinFunctions.decimalToText(new DataTypes_1.Decimal(value));
                    }
                }
                else if (DataTypes_1.TypeValidations.isLongInteger(value)) {
                    return BuiltinFunctions.longIntegerToText(value);
                }
                else if (DataTypes_1.TypeValidations.isDecimal(value)) {
                    return BuiltinFunctions.decimalToText(value);
                }
                else if (DataTypes_1.TypeValidations.isText(value)) {
                    return value;
                }
                else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                    return BuiltinFunctions.booleanToText(value);
                }
                else if (DataTypes_1.TypeValidations.isValidDate(value)) {
                    return BuiltinFunctions.dateToText(value);
                }
                else if (DataTypes_1.TypeValidations.isValidTime(value)) {
                    return BuiltinFunctions.timeToText(value);
                }
                else if (DataTypes_1.TypeValidations.isDateTime(value)) {
                    return BuiltinFunctions.dateTimeToText(value);
                }
                else if (DataTypes_1.TypeValidations.isJsDate(value)) {
                    var dateTime = new DataTypes_1.DateTime(value);
                    if (DataTypes_1.TypeValidations.isValidDate(dateTime)) {
                        return BuiltinFunctions.dateToText(dateTime);
                    }
                    else if (DataTypes_1.TypeValidations.isValidTime(dateTime)) {
                        return BuiltinFunctions.timeToText(dateTime);
                    }
                    else {
                        return BuiltinFunctions.dateTimeToText(dateTime);
                    }
                }
            }
            return DataTypes_1.Constants.DEFAULT_TEXT;
        }
        function convertToPhoneNumber(value) {
            return convertToText(value);
        }
        function convertToEmail(value) {
            if (isConvertibleToEmail(value)) {
                if (DataTypes_1.TypeValidations.isText(value)) {
                    return value;
                }
            }
            return DataTypes_1.Constants.DEFAULT_EMAIL;
        }
        function convertToBoolean(value) {
            if (isConvertibleToBoolean(value)) {
                if (DataTypes_1.TypeValidations.isJsNumber(value)) {
                    return value !== 0;
                }
                else if (DataTypes_1.TypeValidations.isLongInteger(value)) {
                    return !value.eq(0);
                }
                else if (DataTypes_1.TypeValidations.isDecimal(value)) {
                    return !value.eq(0);
                }
                else if (DataTypes_1.TypeValidations.isText(value) && value !== "") {
                    return !/^(false)$/gi.test(value);
                }
                else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                    return value;
                }
            }
            return DataTypes_1.Constants.DEFAULT_BOOLEAN;
        }
        function convertToDate(value) {
            if (isConvertibleToDate(value)) {
                if (DataTypes_1.TypeValidations.isDateTime(value)) {
                    var dateTime = value;
                    return new DataTypes_1.DateTime(dateTime.year, dateTime.month, dateTime.day);
                }
                else if (DataTypes_1.TypeValidations.isJsDate(value)) {
                    var date = value;
                    return new DataTypes_1.DateTime(date.getFullYear(), date.getMonth() + 1, date.getDate());
                }
                else if (DataTypes_1.TypeValidations.isText(value) && value !== "") {
                    if (DataTypes_1.Constants.RFC3339_DATEPART.test(value)) {
                        return DataTypes_1.DateTime.fromISODate(value);
                    }
                    else if (DataTypes_1.Constants.ISO_DATE_FORMAT_REGEXP.test(value)) {
                        return BuiltinFunctions.dateTimeToDate(DataTypes_1.DateTime.fromISODateTime(value));
                    }
                    else {
                        return BuiltinFunctions.textToDate(value);
                    }
                }
            }
            return DataTypes_1.Constants.DEFAULT_DATE;
        }
        function convertToTime(value) {
            if (isConvertibleToTime(value)) {
                if (DataTypes_1.TypeValidations.isDateTime(value)) {
                    var dateTime = value;
                    return new DataTypes_1.DateTime(null, null, null, dateTime.hours, dateTime.minutes, dateTime.seconds, dateTime.milliseconds);
                }
                else if (DataTypes_1.TypeValidations.isJsDate(value)) {
                    var date = value;
                    return new DataTypes_1.DateTime(null, null, null, date.getHours(), date.getMinutes(), date.getSeconds());
                }
                else if (DataTypes_1.TypeValidations.isText(value) && value !== "") {
                    if (DataTypes_1.Constants.RFC3339_TIMEPART.test(value)) {
                        return DataTypes_1.DateTime.fromISOTime(value);
                    }
                    else if (DataTypes_1.Constants.ISO_DATE_FORMAT_REGEXP.test(value)) {
                        return BuiltinFunctions.dateTimeToTime(DataTypes_1.DateTime.fromISODateTime(value));
                    }
                    else {
                        return BuiltinFunctions.textToTime(value);
                    }
                }
            }
            return DataTypes_1.Constants.DEFAULT_TIME;
        }
        function convertToDateTime(value) {
            if (isConvertibleToDateTime(value)) {
                if (DataTypes_1.TypeValidations.isDateTime(value)) {
                    var dateTime = value;
                    return new DataTypes_1.DateTime(dateTime.year, dateTime.month, dateTime.day, dateTime.hours, dateTime.minutes, dateTime.seconds, dateTime.milliseconds);
                }
                else if (DataTypes_1.TypeValidations.isJsDate(value)) {
                    var date = value;
                    return new DataTypes_1.DateTime(date);
                }
                else if (DataTypes_1.TypeValidations.isText(value) && value !== "") {
                    if (DataTypes_1.Constants.ISO_DATE_FORMAT_REGEXP.test(value)) {
                        return DataTypes_1.DateTime.fromISODateTime(value);
                    }
                    else {
                        return BuiltinFunctions.textToDateTime(value);
                    }
                }
            }
            return DataTypes_1.Constants.DEFAULT_DATETIME;
        }
        function convertToBinaryData(value) {
            return value;
        }
        function convertTo(value, type) {
            switch (type) {
                case DataTypes_1.DataTypes.Integer:
                    return convertToInteger(value);
                case DataTypes_1.DataTypes.LongInteger:
                    return convertToLongInteger(value);
                case DataTypes_1.DataTypes.Decimal:
                    return convertToDecimal(value);
                case DataTypes_1.DataTypes.Currency:
                    return convertToCurrency(value);
                case DataTypes_1.DataTypes.Text:
                    return convertToText(value);
                case DataTypes_1.DataTypes.PhoneNumber:
                    return convertToPhoneNumber(value);
                case DataTypes_1.DataTypes.Email:
                    return convertToEmail(value);
                case DataTypes_1.DataTypes.Boolean:
                    return convertToBoolean(value);
                case DataTypes_1.DataTypes.Date:
                    return convertToDate(value);
                case DataTypes_1.DataTypes.Time:
                    return convertToTime(value);
                case DataTypes_1.DataTypes.DateTime:
                    return convertToDateTime(value);
                case DataTypes_1.DataTypes.BinaryData:
                    return convertToBinaryData(value);
                default:
                    return null;
            }
        }
        JSConversions.convertTo = convertTo;
        function typeConvertRecord(source, target, convFunction) {
            return convFunction(source, target);
        }
        JSConversions.typeConvertRecord = typeConvertRecord;
        function typeConvertRecordList(source, target, convFunction) {
            var entityListIndex = 0;
            while (entityListIndex < source.length) {
                target.append(convFunction(source.getItem(entityListIndex), target.newItem()));
                entityListIndex++;
            }
            return target;
        }
        JSConversions.typeConvertRecordList = typeConvertRecordList;
    })(JSConversions = exports.JSConversions || (exports.JSConversions = {}));
    var JSNodeParamConverter;
    (function (JSNodeParamConverter) {
        function trunc(value) {
            return value - (value % 1);
        }
        function to(value, dataType) {
            return basicTypetoJSNodeParam(value, dataType);
        }
        JSNodeParamConverter.to = to;
        function from(value, dataType) {
            return jsNodeParamToBasicType(value, dataType);
        }
        JSNodeParamConverter.from = from;
        function basicTypetoJSNodeParam(value, valueType) {
            switch (valueType) {
                case DataTypes_1.DataTypes.Integer:
                    return value;
                case DataTypes_1.DataTypes.LongInteger:
                    var longVal = value;
                    DataTypes_1.TypeValidations.ensureNumberInsideBounds(longVal);
                    return longVal.toNumber();
                case DataTypes_1.DataTypes.Decimal:
                case DataTypes_1.DataTypes.Currency:
                    var decVal = value;
                    DataTypes_1.TypeValidations.ensureNumberPrecision(decVal);
                    DataTypes_1.TypeValidations.ensureNumberInsideBounds(decVal);
                    return decVal.toNumber();
                case DataTypes_1.DataTypes.Text:
                case DataTypes_1.DataTypes.PhoneNumber:
                case DataTypes_1.DataTypes.Email:
                    return value;
                case DataTypes_1.DataTypes.Date:
                case DataTypes_1.DataTypes.DateTime:
                case DataTypes_1.DataTypes.Time:
                    var dateVal = value;
                    return dateVal.toNative();
                case DataTypes_1.DataTypes.Boolean:
                    return value;
                case DataTypes_1.DataTypes.Record:
                case DataTypes_1.DataTypes.RecordList:
                    throw new TypeError("Records and Record lists are not basic types");
                case DataTypes_1.DataTypes.BinaryData:
                    var binValue = value;
                    return typeof value === "string" ? value : binValue.content;
                case DataTypes_1.DataTypes.Object:
                    return value;
                default:
                    return value;
            }
        }
        function jsNodeParamToBasicType(value, targetType) {
            switch (targetType) {
                case DataTypes_1.DataTypes.Integer:
                    if (DataTypes_1.TypeValidations.isValidJsNumber(value)) {
                        DataTypes_1.TypeValidations.ensureIntegerInsideBounds(value);
                        return trunc(value);
                    }
                    break;
                case DataTypes_1.DataTypes.LongInteger:
                    if (DataTypes_1.TypeValidations.isValidJsNumber(value)) {
                        DataTypes_1.TypeValidations.ensureLongIntegerInsideBounds(value);
                        return DataTypes_1.LongInteger.fromNumber(trunc(value));
                    }
                    break;
                case DataTypes_1.DataTypes.Decimal:
                case DataTypes_1.DataTypes.Currency:
                    if (DataTypes_1.TypeValidations.isValidJsNumber(value)) {
                        DataTypes_1.TypeValidations.ensureDecimalInsideBounds(value);
                        return new DataTypes_1.Decimal(value);
                    }
                    break;
                case DataTypes_1.DataTypes.Boolean:
                    if (DataTypes_1.TypeValidations.isBoolean(value)) {
                        return value;
                    }
                    break;
                case DataTypes_1.DataTypes.Text:
                case DataTypes_1.DataTypes.PhoneNumber:
                case DataTypes_1.DataTypes.Email:
                    if (DataTypes_1.TypeValidations.isText(value)) {
                        return value;
                    }
                    else if (DataTypes_1.TypeValidations.isValidJsNumber(value)) {
                        DataTypes_1.TypeValidations.ensureDecimalInsideBounds(value);
                        return BuiltinFunctions.decimalToText(new DataTypes_1.Decimal(value));
                    }
                    else if (DataTypes_1.TypeValidations.isBoolean(value)) {
                        return BuiltinFunctions.booleanToText(value);
                    }
                    break;
                case DataTypes_1.DataTypes.Date:
                    if (DataTypes_1.TypeValidations.isValidJsDate(value)) {
                        var jsDate = value;
                        return new DataTypes_1.DateTime(jsDate.getFullYear(), jsDate.getMonth() + 1, jsDate.getDate());
                    }
                    break;
                case DataTypes_1.DataTypes.DateTime:
                    if (DataTypes_1.TypeValidations.isValidJsDate(value)) {
                        return new DataTypes_1.DateTime(value);
                    }
                    break;
                case DataTypes_1.DataTypes.Time:
                    if (DataTypes_1.TypeValidations.isValidJsDate(value)) {
                        var jsDate = value;
                        return new DataTypes_1.DateTime(null, null, null, jsDate.getHours(), jsDate.getMinutes(), jsDate.getSeconds(), jsDate.getMilliseconds());
                    }
                    break;
                case DataTypes_1.DataTypes.BinaryData:
                    if (DataTypes_1.TypeValidations.hasBinaryDataInterface(value)) {
                        return new DataTypes_1.BinaryData(value.content, value.url);
                    }
                    return new DataTypes_1.BinaryData(value);
                case DataTypes_1.DataTypes.Object:
                    return value;
                default:
                    break;
            }
            throw new Exceptions_1.Exceptions.InvalidJavascriptType("Cannot assign a JavaScript " + typeof value + " with value " + (value === undefined || value === null ? JSON.stringify(value) : value.toString()) + " to an output parameter of type " + DataTypes_1.DataTypes[targetType]);
        }
    })(JSNodeParamConverter = exports.JSNodeParamConverter || (exports.JSNodeParamConverter = {}));
    var JSONConverter;
    (function (JSONConverter) {
        var ToMethodCache = new Map();
        var FromMethodCache = new Map();
        function to(value, serializeDefaultValues, useUnixDateFormat, dataType, defaultValue) {
            if (dataType === void 0) { dataType = DataTypes_1.DataTypes.Record; }
            if (value === undefined || value === null) {
                return;
            }
            if (value instanceof DataTypes_1.GenericRecord) {
                var record = value;
                var recordType = record.constructor;
                var converter = ToMethodCache.get(recordType);
                if (!converter) {
                    var attributes = record.getAttributes();
                    var toFuncCode_2 = "return function to(record, serializeDefaultValues, useUnixDateFormat) {\n";
                    toFuncCode_2 += "     if (serializeDefaultValues === void 0) { serializeDefaultValues = true; }\n";
                    toFuncCode_2 += "     return {\n";
                    attributes.forEach(function (attr, index) {
                        if (attr.nameForJson !== "") {
                            if (attr.dataType === DataTypes_1.DataTypes.Record || attr.dataType === DataTypes_1.DataTypes.RecordList) {
                                toFuncCode_2 += "        \"" + attr.nameForJson + "\": toJSON(record." + attr.attrName + ", serializeDefaultValues, useUnixDateFormat),\n";
                            }
                            else {
                                toFuncCode_2 += "        \"" + attr.nameForJson + "\": basicTypeToJSON(record." + attr.attrName + ", attributes[" + index + "].dataType, attributes[" + index + "].defaultValue, " + (attr.mandatory ? "true" : "serializeDefaultValues") + ", useUnixDateFormat),\n";
                            }
                        }
                    });
                    toFuncCode_2 += "    };\n";
                    toFuncCode_2 += "};";
                    converter = new Function("toJSON", "basicTypeToJSON", "attributes", toFuncCode_2)(to, basicTypeToJSON, attributes);
                    ToMethodCache.set(recordType, converter);
                }
                return converter(value, serializeDefaultValues, useUnixDateFormat);
            }
            else if (value instanceof DataTypes_1.List) {
                var list = value;
                var listItemType = list.constructor.getItemType();
                var result = [];
                for (var i = 0; i < list.length; i++) {
                    result.push(to(list.getItem(i), serializeDefaultValues, useUnixDateFormat, listItemType));
                }
                return result;
            }
            else {
                return basicTypeToJSON(value, dataType, defaultValue === undefined ? DataTypes_1.defaultForType(dataType) : defaultValue, serializeDefaultValues, useUnixDateFormat);
            }
        }
        JSONConverter.to = to;
        function from(jsObject, dataType, useUnixDateFormat, defaultValue) {
            if (isGenericRecordType(dataType)) {
                var recordType = dataType;
                var converter = FromMethodCache.get(recordType);
                if (!converter) {
                    var attributes = recordType.getAttributes();
                    var fromFuncCode_2 = "return function from(obj, useUnixDateFormat) {\n";
                    fromFuncCode_2 += "     if (!obj) { obj = {}; }\n";
                    fromFuncCode_2 += "     return new classDef(new classDef.RecordClass({\n";
                    attributes.forEach(function (attr, index) {
                        if (attr.nameForJson !== "") {
                            if (attr.dataType === DataTypes_1.DataTypes.Record || attr.dataType === DataTypes_1.DataTypes.RecordList) {
                                fromFuncCode_2 += "        " + attr.attrName + ": GenericRecord.getData(fromJSON(obj[\"" + attr.nameForJson + "\"], attributes[" + index + "].complexType, useUnixDateFormat)),\n";
                            }
                            else {
                                fromFuncCode_2 += "        " + attr.attrName + ": jsonToBasicType(obj[\"" + attr.nameForJson + "\"], attributes[" + index + "].dataType, attributes[" + index + "].defaultValue, useUnixDateFormat),\n";
                            }
                        }
                    });
                    fromFuncCode_2 += "    }));\n";
                    fromFuncCode_2 += "};";
                    converter = new Function("fromJSON", "jsonToBasicType", "GenericRecord", "attributes", "classDef", fromFuncCode_2)(from, jsonToBasicType, DataTypes_1.GenericRecord, attributes, dataType);
                    FromMethodCache.set(recordType, converter);
                }
                return converter(jsObject, useUnixDateFormat);
            }
            else if (isGenericRecordListType(dataType) || isBasicTypeListType(dataType)) {
                if (dataType.getItemType() === undefined || dataType.getItemType() === null) {
                    throw Error("A List can only be deserialized if its ItemType is defined.");
                }
                var list = jsObject;
                if (list === null || list === undefined) {
                    list = [];
                }
                if (!(list.constructor === Array)) {
                    throw new TypeError("Could not convert '" + list + "' to List");
                }
                var constructableDataType = dataType;
                var result = new constructableDataType();
                result.pushAll(list.map(function (item) { return from(item, dataType.getItemType(), useUnixDateFormat); }));
                return result;
            }
            else {
                return jsonToBasicType(jsObject, dataType, defaultValue === undefined ? DataTypes_1.defaultForType(dataType) : defaultValue, useUnixDateFormat);
            }
        }
        JSONConverter.from = from;
        function basicTypeToJSON(value, valueType, defaultValue, serializeDefaultValues, useUnixDateFormat) {
            if (serializeDefaultValues === void 0) { serializeDefaultValues = true; }
            if (serializeDefaultValues === false && DataTypes_1.equals(value, defaultValue)) {
                return null;
            }
            switch (valueType) {
                case DataTypes_1.DataTypes.Time:
                    return value.toISOTime();
                case DataTypes_1.DataTypes.Date:
                    return value.toISODate();
                case DataTypes_1.DataTypes.DateTime:
                    if (useUnixDateFormat === true) {
                        return "" + Math.floor(value.getTime() / 1000);
                    }
                    return value.toString().replace(/\.\d+/, "");
                default:
                    return JSNodeParamConverter.to(value, valueType);
            }
        }
        function jsonToBasicType(value, targetType, defaultValue, useUnixDateFormat) {
            if (value === undefined || value === null) {
                return defaultValue;
            }
            switch (targetType) {
                case DataTypes_1.DataTypes.Integer:
                    return jsonToInteger(value);
                case DataTypes_1.DataTypes.LongInteger:
                    return jsonToLongInteger(value);
                case DataTypes_1.DataTypes.Currency:
                case DataTypes_1.DataTypes.Decimal:
                    return jsonToDecimal(value);
                case DataTypes_1.DataTypes.DateTime:
                    return jsonToDateTime(value, useUnixDateFormat);
                default:
                    return ServerDataConverter.from(value, targetType);
            }
        }
        function jsonToInteger(value) {
            var decValue;
            if (DataTypes_1.Constants.FORMAT.numberFormat.getRegExpForInteger().test(value)) {
                decValue = new DataTypes_1.Decimal(value);
            }
            else if (DataTypes_1.Constants.FORMAT.numberFormat.getRegExpForJSNumber().test(value)) {
                decValue = new DataTypes_1.Decimal(+value);
            }
            if (decValue === undefined || !decValue.isInteger() || !BuiltinFunctions.decimalToIntegerValidate(decValue)) {
                throw new Exceptions_1.Exceptions.Exception("Could not convert '" + value + "' to Integer");
            }
            return BuiltinFunctions.decimalToInteger(decValue);
        }
        function jsonToLongInteger(value) {
            var decValue;
            if (DataTypes_1.Constants.FORMAT.numberFormat.getRegExpForInteger().test(value)) {
                decValue = new DataTypes_1.Decimal(value);
            }
            else if (DataTypes_1.Constants.FORMAT.numberFormat.getRegExpForJSNumber().test(value)) {
                decValue = new DataTypes_1.Decimal(+value);
            }
            if (decValue === undefined ||
                !decValue.isInteger() ||
                !BuiltinFunctions.decimalToLongIntegerValidate(decValue)) {
                throw new Exceptions_1.Exceptions.Exception("Could not convert '" + value + "' to Long Integer");
            }
            return BuiltinFunctions.decimalToLongInteger(decValue);
        }
        function jsonToDecimal(value) {
            var decValue;
            if (DataTypes_1.Constants.FORMAT.numberFormat.getRegExpForInteger().test(value)) {
                decValue = new DataTypes_1.Decimal(value);
            }
            else if (DataTypes_1.Constants.FORMAT.numberFormat.getRegExpForJSNumber().test(value)) {
                decValue = new DataTypes_1.Decimal(+value);
            }
            if (decValue === undefined ||
                decValue.lt(DataTypes_1.Constants.MIN_DECIMAL_VALUE) ||
                decValue.gt(DataTypes_1.Constants.MAX_DECIMAL_VALUE)) {
                throw new Exceptions_1.Exceptions.Exception("Could not convert '" + value + "' to Decimal");
            }
            return decValue;
        }
        function jsonToDateTime(value, useUnixDateFormat) {
            if (useUnixDateFormat) {
                if (value instanceof Date) {
                    value = new DataTypes_1.DateTime(value.getTime());
                }
                try {
                    return new DataTypes_1.DateTime(+value * 1000);
                }
                catch (e) {
                    throw new Exceptions_1.Exceptions.Exception("Could not convert '" + value + "' to DateTime");
                }
            }
            else {
                if (!JSConversions.isConvertibleTo(value, DataTypes_1.DataTypes.DateTime)) {
                    throw new Exceptions_1.Exceptions.Exception("Could not convert '" + value + "' to DateTime");
                }
                return ServerDataConverter.from(value, DataTypes_1.DataTypes.DateTime);
            }
        }
    })(JSONConverter = exports.JSONConverter || (exports.JSONConverter = {}));
    var NewJSONConverter;
    (function (NewJSONConverter) {
        function serializeBasicType(value, valueType, defaultValue, serializeDefaultValues, useUnixDateFormat, enforceDefaultValueSerializationAtThisLevel) {
            if (serializeDefaultValues === void 0) { serializeDefaultValues = true; }
            if (enforceDefaultValueSerializationAtThisLevel === void 0) { enforceDefaultValueSerializationAtThisLevel = false; }
            if (serializeDefaultValues === false &&
                !enforceDefaultValueSerializationAtThisLevel &&
                DataTypes_1.equals(value, defaultValue)) {
                return;
            }
            switch (valueType) {
                case DataTypes_1.DataTypes.Time:
                    return value.toISOTime();
                case DataTypes_1.DataTypes.Date:
                    return value.toISODate();
                case DataTypes_1.DataTypes.DateTime:
                    if (useUnixDateFormat === true) {
                        return "" + Math.floor(value.getTime() / 1000);
                    }
                    return value.toString().replace(/\.\d+/, "");
                case DataTypes_1.DataTypes.LongInteger:
                    var longVal = value;
                    DataTypes_1.TypeValidations.ensureNumberInsideBounds(longVal);
                    return longVal.toNumber();
                case DataTypes_1.DataTypes.Decimal:
                case DataTypes_1.DataTypes.Currency:
                    var decVal = value;
                    DataTypes_1.TypeValidations.ensureNumberPrecision(decVal);
                    DataTypes_1.TypeValidations.ensureNumberInsideBounds(decVal);
                    return decVal.toNumber();
                case DataTypes_1.DataTypes.Record:
                case DataTypes_1.DataTypes.RecordList:
                    throw new TypeError("Records and Record lists are not basic types");
                case DataTypes_1.DataTypes.BinaryData:
                    var binValue = value;
                    return typeof value === "string" ? value : binValue.content;
                default:
                    return value;
            }
        }
        function to(_a) {
            var value = _a.value, serializeDefaultValues = _a.serializeDefaultValues, useUnixDateFormat = _a.useUnixDateFormat, _b = _a.dataType, dataType = _b === void 0 ? DataTypes_1.DataTypes.Record : _b, defaultValue = _a.defaultValue, _c = _a.enforceDefaultValueSerializationAtThisLevel, enforceDefaultValueSerializationAtThisLevel = _c === void 0 ? false : _c;
            if (value === undefined || value === null) {
                return;
            }
            if (value instanceof DataTypes_1.GenericRecord) {
                return serializeRecord(value, serializeDefaultValues, useUnixDateFormat, enforceDefaultValueSerializationAtThisLevel);
            }
            else if (value instanceof DataTypes_1.List) {
                return serializeList(value, serializeDefaultValues, useUnixDateFormat, enforceDefaultValueSerializationAtThisLevel);
            }
            else {
                return serializeBasicType(value, dataType, defaultValue === undefined ? DataTypes_1.defaultForType(dataType) : defaultValue, serializeDefaultValues, useUnixDateFormat, enforceDefaultValueSerializationAtThisLevel);
            }
        }
        NewJSONConverter.to = to;
        function serializeRecord(value, serializeDefaultValues, useUnixDateFormat, enforceDefaultValueSerializationAtThisLevel) {
            if (enforceDefaultValueSerializationAtThisLevel === void 0) { enforceDefaultValueSerializationAtThisLevel = false; }
            var recordObject = value.getAttributes().reduce(function (agg, element) {
                if (element.dataType === DataTypes_1.DataTypes.Record || element.dataType === DataTypes_1.DataTypes.RecordList) {
                    var record = to({
                        value: value[element.attrName],
                        serializeDefaultValues: serializeDefaultValues,
                        useUnixDateFormat: useUnixDateFormat,
                    });
                    if (record) {
                        agg[element.nameForJson] = record;
                    }
                }
                else {
                    var basicType = serializeBasicType(value[element.attrName], element.dataType, element.defaultValue, serializeDefaultValues, useUnixDateFormat);
                    if (basicType !== undefined) {
                        agg[element.nameForJson] = basicType;
                    }
                }
                return agg;
            }, {});
            if (Object.keys(recordObject).length !== 0 || enforceDefaultValueSerializationAtThisLevel) {
                return recordObject;
            }
        }
        function serializeList(value, serializeDefaultValues, useUnixDateFormat, enforceDefaultValueSerializationAtThisLevel) {
            if (enforceDefaultValueSerializationAtThisLevel === void 0) { enforceDefaultValueSerializationAtThisLevel = false; }
            var jsonElement = [];
            var listItemType = value.constructor.getItemType();
            for (var i = 0; i < value.length; i++) {
                jsonElement.push(to({
                    value: value.getItem(i),
                    serializeDefaultValues: serializeDefaultValues,
                    useUnixDateFormat: useUnixDateFormat,
                    dataType: listItemType,
                    enforceDefaultValueSerializationAtThisLevel: true,
                }));
            }
            if (jsonElement.length > 0 || serializeDefaultValues || enforceDefaultValueSerializationAtThisLevel) {
                return jsonElement;
            }
        }
    })(NewJSONConverter = exports.NewJSONConverter || (exports.NewJSONConverter = {}));
    var LocalStorageConverter;
    (function (LocalStorageConverter) {
        LocalStorageConverter.typeDefaultValue = DatabaseTypeUtils_1.typeDefaultValue;
        LocalStorageConverter.convertToModelDataType = DatabaseTypeUtils_1.convertToModelDataType;
        LocalStorageConverter.typeDisplayName = DatabaseTypeUtils_1.typeDisplayName;
        var NULLDATE_IN_DB = "1900-01-01 00:00:00";
        var FromMethodCache = new Map();
        function from(rowOrRowList, dataType, indexRefOrRowReader, attributeOrder) {
            if (isGenericRecordType(dataType)) {
                var row = rowOrRowList;
                var recordType = dataType;
                var indexRef = indexRefOrRowReader;
                var converter = FromMethodCache.get(recordType);
                if (!converter) {
                    var attributes = recordType.getAttributes();
                    var fromFuncCode_3 = "return function from(row, indexRef, readerImplementation, attributeOrder) {\n";
                    fromFuncCode_3 += "     var data = null;\n";
                    fromFuncCode_3 += "     if (attributeOrder && attributeOrder.length > 0) {\n";
                    fromFuncCode_3 += "         data = {\n";
                    attributes.forEach(function (attr, index) {
                        if (attr.dataType !== DataTypes_1.DataTypes.RecordList) {
                            fromFuncCode_3 += "             " + attr.attrName + ": null,\n";
                        }
                    });
                    fromFuncCode_3 += "         };\n";
                    fromFuncCode_3 += "         for (var i = 0; i < attributeOrder.length; i++) {\n";
                    fromFuncCode_3 += "             var attrName = attributeOrder[i];\n";
                    fromFuncCode_3 +=
                        "             var attr = attributes.filter(function(attr) { return attr.attrName === attrName; })[0];\n";
                    fromFuncCode_3 += "             if (attr.complexType) {\n";
                    fromFuncCode_3 += "                 data[attrName] = fromLocalStorage(row, attr.complexType, indexRef);\n";
                    fromFuncCode_3 += "             } else {\n";
                    fromFuncCode_3 += "                 data[attrName] = readerImplementation(row, indexRef.value++, attr.name, attr.dataType);\n";
                    fromFuncCode_3 += "             }\n";
                    fromFuncCode_3 += "         }\n";
                    fromFuncCode_3 += "     } else {\n";
                    fromFuncCode_3 += "         data = {\n";
                    attributes.forEach(function (attr, index) {
                        if (attr.dataType !== DataTypes_1.DataTypes.RecordList) {
                            if (attr.dataType === DataTypes_1.DataTypes.Record && dataType.isAnonymousRecord()) {
                                fromFuncCode_3 += "            " + attr.attrName + ": fromLocalStorage(row, attributes[" + index + "].complexType, indexRef),\n";
                            }
                            else {
                                fromFuncCode_3 += "            " + attr.attrName + ": readerImplementation(row, indexRef.value++, attributes[" + index + "].name, attributes[" + index + "].dataType),\n";
                            }
                        }
                    });
                    fromFuncCode_3 += "        };\n";
                    fromFuncCode_3 += "     }\n";
                    fromFuncCode_3 += "     return new classDef.RecordClass(data);\n";
                    fromFuncCode_3 += "};";
                    converter = new Function("fromLocalStorage", "GenericRecord", "attributes", "classDef", fromFuncCode_3)(from, DataTypes_1.GenericRecord, attributes, dataType);
                    FromMethodCache.set(recordType, converter);
                }
                return converter(row, indexRef, getAttributeReaderImplementation(dataType), attributeOrder);
            }
            else if (isGenericRecordListType(dataType)) {
                if (dataType.getItemType() === undefined || dataType.getItemType() === null) {
                    throw Error("A List can only be deserialized if its ItemType is defined.");
                }
                var rowList = rowOrRowList;
                var itemType = dataType.getItemType();
                var rowReader = indexRefOrRowReader;
                var constructableDataType = dataType;
                var result = new constructableDataType();
                var items = [];
                for (var i = 0; i < rowList.length; i++) {
                    items.push(new itemType(rowReader(null, rowList.item(i))));
                }
                result.pushAll(items);
                return result;
            }
            else {
                var type = dataType;
                throw new Error("Unable to read data from Local Storage. Unknown type " + (type && type.name ? type.name : type));
            }
        }
        LocalStorageConverter.from = from;
        function convertDataTypeToDBDataType(runtimeType) {
            var dbType = DatabaseTypeUtils_1.dataTypeToDBDataType[runtimeType];
            if (dbType === undefined) {
                return Interfaces_1.ClientDB.DBDataType.UNKNOWN;
            }
            return dbType;
        }
        function getAttributeReaderImplementation(type) {
            return type.isAnonymousRecord() ? namedAttributeReaderImplementation : attributeReaderImplementation;
        }
        function attributeReaderImplementation(dbRecord, currIndex, name, runtimeType) {
            return LocalStorageConverter.deserializeFromDB(dbRecord["o" + currIndex], convertDataTypeToDBDataType(runtimeType));
        }
        function namedAttributeReaderImplementation(dbRecord, currIndex, name, runtimeType) {
            return LocalStorageConverter.deserializeFromDB(dbRecord[name], convertDataTypeToDBDataType(runtimeType));
        }
        function maskValue(value, mask) {
            var length = mask.length;
            var strValue = value.toString();
            return mask.substr(0, Math.max(0, length - strValue.length)) + strValue;
        }
        function serializeToDB(value, typeInfo) {
            if (typeInfo.isEntityReference && DataTypes_1.equals(value, LocalStorageConverter.typeDefaultValue(typeInfo.type))) {
                return null;
            }
            switch (typeInfo.type) {
                case Interfaces_1.ClientDB.DBDataType.INTEGER:
                    return value;
                case Interfaces_1.ClientDB.DBDataType.LONGINTEGER:
                    var longValue = value;
                    return longValue ? longValue.toString() : null;
                case Interfaces_1.ClientDB.DBDataType.DECIMAL:
                    var decimalValue = value;
                    return !typeInfo.decimals ? decimalValue.toString() : decimalValue.toFixed(typeInfo.decimals);
                case Interfaces_1.ClientDB.DBDataType.TEXT:
                    return value;
                case Interfaces_1.ClientDB.DBDataType.BOOLEAN:
                    var booleanValue = value;
                    return booleanValue ? 1 : 0;
                case Interfaces_1.ClientDB.DBDataType.DATE_TIME:
                    var dateTimeValue = value.toNative();
                    if (!Settings_1.getEnvParams().DbNullDatesTZAware && value.eq(DataTypes_1.DateTime.defaultValue)) {
                        return NULLDATE_IN_DB;
                    }
                    dateTimeValue = value.toNative();
                    return (maskValue(dateTimeValue.getUTCFullYear(), "0000") +
                        "-" +
                        maskValue(dateTimeValue.getUTCMonth() + 1, "00") +
                        "-" +
                        maskValue(dateTimeValue.getUTCDate(), "00") +
                        " " +
                        maskValue(dateTimeValue.getUTCHours(), "00") +
                        ":" +
                        maskValue(dateTimeValue.getUTCMinutes(), "00") +
                        ":" +
                        maskValue(dateTimeValue.getUTCSeconds(), "00"));
                case Interfaces_1.ClientDB.DBDataType.DATE:
                    var dateValue = value.toNative();
                    return (maskValue(dateValue.getFullYear(), "0000") +
                        "-" +
                        maskValue(dateValue.getMonth() + 1, "00") +
                        "-" +
                        maskValue(dateValue.getDate(), "00"));
                case Interfaces_1.ClientDB.DBDataType.TIME:
                    var timeValue = value.toNative();
                    return ("1900-01-01" +
                        " " +
                        maskValue(timeValue.getHours(), "00") +
                        ":" +
                        maskValue(timeValue.getMinutes(), "00") +
                        ":" +
                        maskValue(timeValue.getSeconds(), "00"));
                case Interfaces_1.ClientDB.DBDataType.BINARY_DATA:
                    var binary = value;
                    return binary.content === undefined ? null : binary.content;
                default:
                    throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to serialize " + value + " to a database value.");
            }
        }
        LocalStorageConverter.serializeToDB = serializeToDB;
        function deserializeFromDB(dbValue, dataType) {
            if (dbValue === null) {
                return LocalStorageConverter.typeDefaultValue(dataType);
            }
            switch (dataType) {
                case Interfaces_1.ClientDB.DBDataType.INTEGER:
                    return dbValue;
                case Interfaces_1.ClientDB.DBDataType.LONGINTEGER:
                    return DataTypes_1.LongInteger.fromValue(dbValue);
                case Interfaces_1.ClientDB.DBDataType.DECIMAL:
                    var rawDecimalValue = dbValue;
                    return new DataTypes_1.Decimal(rawDecimalValue);
                case Interfaces_1.ClientDB.DBDataType.TEXT:
                    return dbValue;
                case Interfaces_1.ClientDB.DBDataType.BOOLEAN:
                    var rawBooleanValue = dbValue;
                    return rawBooleanValue !== 0;
                case Interfaces_1.ClientDB.DBDataType.DATE_TIME:
                case Interfaces_1.ClientDB.DBDataType.DATE:
                case Interfaces_1.ClientDB.DBDataType.TIME:
                    var DateTimeDbParseRegExp = /^(\d{4})-(\d{2})-(\d{2})( (\d{2}):(\d{2}):(\d{2}))?$/;
                    var rawDateTimeValue = dbValue;
                    var dtParts = DateTimeDbParseRegExp.exec(rawDateTimeValue);
                    var nativeDate = new Date();
                    switch (dataType) {
                        case Interfaces_1.ClientDB.DBDataType.DATE_TIME:
                            if (dbValue === NULLDATE_IN_DB && !Settings_1.getEnvParams().DbNullDatesTZAware) {
                                return DataTypes_1.DateTime.defaultValue;
                            }
                            nativeDate.setUTCFullYear(parseInt(dtParts[1], 10), parseInt(dtParts[2], 10) - 1, parseInt(dtParts[3], 10));
                            nativeDate.setUTCHours(parseInt(dtParts[5], 10) || 0, parseInt(dtParts[6], 10) || 0, parseInt(dtParts[7], 10) || 0, 0);
                            break;
                        case Interfaces_1.ClientDB.DBDataType.DATE:
                            nativeDate.setFullYear(parseInt(dtParts[1], 10), parseInt(dtParts[2], 10) - 1, parseInt(dtParts[3], 10));
                            nativeDate.setHours(0, 0, 0, 0);
                            break;
                        case Interfaces_1.ClientDB.DBDataType.TIME:
                            nativeDate.setFullYear(1900, 0, 1);
                            nativeDate.setHours(parseInt(dtParts[5], 10) || 0, parseInt(dtParts[6], 10) || 0, parseInt(dtParts[7], 10) || 0, 0);
                            break;
                        default:
                            break;
                    }
                    return new DataTypes_1.DateTime(nativeDate);
                case Interfaces_1.ClientDB.DBDataType.BINARY_DATA:
                    return new DataTypes_1.BinaryData(dbValue);
                default:
                    throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to deserialize " + dbValue + " to a runtime value.");
            }
        }
        LocalStorageConverter.deserializeFromDB = deserializeFromDB;
        function deserializeLazyBinaryFromDB(lazyLoad) {
            return new DataTypes_1.BinaryData(null, null, lazyLoad);
        }
        LocalStorageConverter.deserializeLazyBinaryFromDB = deserializeLazyBinaryFromDB;
    })(LocalStorageConverter = exports.LocalStorageConverter || (exports.LocalStorageConverter = {}));
});
//# sourceMappingURL=DataConversion.js.map;
